import React, { useEffect } from "react";
import { useLocaleContext } from "../../context/LocaleContext";
import { usePlayerContext } from "../../context/PlayerContext";
import { useStreamContext } from "../../context/StreamContext";
import { CButton } from "../../components/UI";
import PlayerBlock from "../PlayerBlock";
import ButtonQuestionBlock from "../ButtonQuestionBlock";
import "./style.scss";

export default ({isShow, settings}) => {
    const {get: getLocale} = useLocaleContext();
    const {isShowPlayerHalls, setIsShowPlayerHalls, isNotMountMiniPlayer} = usePlayerContext();
    const {stream} = useStreamContext();
    const className = "player-banner";

    const toggleShowPlayer = () => setIsShowPlayerHalls(status => !status);

    useEffect(() => () => {
        isNotMountMiniPlayer.current = false;
    }, [stream]);

    if (!isShow) {
        return null;
    }

    if (isShowPlayerHalls) {
        return (
            <div className={`${className}--wrapper`}>
                <PlayerBlock onHidePlayer={toggleShowPlayer} settings={settings} isShowSideModuleByDefault={false} />
            </div>
        )
    }

    return (
        <>
            <div>
                <section className={`page-block ${className}`}>
                    <span className={`${className}--title`}>
                        {getLocale('playerBanner.streamAvailable')}
                    </span>

                    <CButton
                        size="lg"
                        label={getLocale('playerBanner.show')}
                        icon="play"
                        iconPosition="left"
                        onClick={toggleShowPlayer}
                    />
                </section>
            </div>
            <ButtonQuestionBlock settings={settings} />
        </>
    );
}
